import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import t from 'prop-types'

import {
  Loading,
  Notifications,
  Chart,
  Segment,
  Grid,
} from 'components/UI'

class RadiatorTimeline extends Component {
  render () {
    const {
      loading,
      error,
      radiator,
    } = this.props.data || { loading: true }

    if (error) return <Notifications.Error message={error.message} />

    return (
      <div>
        <Grid.Row>
          <Grid.Col>
            <Segment centered>
              <Chart.LineTitle
                showFans
                title='Room and Radiator Temperatues'
              />
              { loading ? <Loading height={280} /> : (
                <Chart.Timeline
                  data={radiator.readings || []}
                  dataKey1='roomTemp'
                  dataKey2='radTemp'
                  onZoom={this.props.onZoom}
                  highlightDataKeys={['fanPwm', 'fanPwm2']}
                />
              )}
            </Segment>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col>
            <Segment centered>
              <Chart.LineTitle
                showFans
                title='Steam Inlet and Outlet Temperatures'
              />
              { loading ? <Loading height={280} /> : (
                <Chart.Timeline
                  data={radiator.readings || []}
                  dataKey1='thermTemp1'
                  dataKey2='thermTemp2'
                  onZoom={this.props.onZoom}
                  highlightDataKeys={['fanPwm', 'fanPwm2']}
                />
              )}
            </Segment>
          </Grid.Col>
        </Grid.Row>
      </div>
    )
  }
}

RadiatorTimeline.propTypes = {
  onZoom: t.func.isRequired,
}

const RadiatorTimelineQuery = gql`
  query RadiatorTimelineQuery($id: Int!, $from: String!, $to: String!) {
    radiator(id: $id) {
      readings(from: $from to: $to) {
        roomTemp
        radTemp
        fanPwm
        fanPwm2
        thermTemp1
        thermTemp2
        UTCTimestamp
      }
    }
  }
`
export default graphql(RadiatorTimelineQuery, {
  skip: ownProps => !ownProps.radiatorId,
  options: ({ radiatorId, from, to }) => ({
    variables: {
      id: radiatorId,
      from: String(from),
      to: String(to),
    },
    notifyOnNetworkStatusChange: true,
  }),
})(RadiatorTimeline)



// WEBPACK FOOTER //
// ./src/components/Radiator/RadiatorTimeline.jsx